import React, { useState } from 'react'
import { Tabs } from 'antd'
import FadeIn from 'src/components/styled/FadeIn'
import HeaderScreen from 'src/components/shared/header-screen/HeaderScreen'
import { useSupplierInvitesCounts } from 'src/context/SupplierInvitesCountsContext'
import {
  DEFAULT_SUPPLIERS_TAB_LABEL,
  PENDING_INVITES_TAB_LABEL,
  SUPPLIER_INVITES_PAGE_TITLE,
} from 'src/utils/supplierInvitesAdminCopy'
import {
  SUPPLIER_INVITES_BADGE_COLORS,
  SupplierInvitesTabLabel,
} from 'src/utils/supplierInvitesCounts'
import styled from 'styled-components/macro'
import AdminDefaultSuppliers from './AdminDefaultSuppliers'
import AdminPendingInvites from './AdminPendingInvites'

const AdminSupplierInvites = () => {
  const [activeTab, setActiveTab] = useState('pending')
  const { pendingCount, defaultSuppliersCount } = useSupplierInvitesCounts()

  return (
    <Wrapper>
      <HeaderScreen title={SUPPLIER_INVITES_PAGE_TITLE} />
      <StyledTabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type='card'
        destroyInactiveTabPane={false}
      >
        <Tabs.TabPane
          tab={
            <SupplierInvitesTabLabel
              label={PENDING_INVITES_TAB_LABEL}
              count={pendingCount}
              badgeColor={SUPPLIER_INVITES_BADGE_COLORS.pending}
            />
          }
          key='pending'
        >
          <AdminPendingInvites />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <SupplierInvitesTabLabel
              label={DEFAULT_SUPPLIERS_TAB_LABEL}
              count={defaultSuppliersCount}
              badgeColor={SUPPLIER_INVITES_BADGE_COLORS.defaultSuppliers}
            />
          }
          key='default-suppliers'
        >
          <AdminDefaultSuppliers />
        </Tabs.TabPane>
      </StyledTabs>
    </Wrapper>
  )
}

const Wrapper = styled(FadeIn)`
  .restrictShrink {
    min-width: 95px;
  }
`

const StyledTabs = styled(Tabs)`
  margin-top: 16px;
`

export default AdminSupplierInvites
